// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF","cRed":"#ed0000","AddBtn":"AddBtn_AddBtn__3inbU","AddBtnDisabled":"AddBtn_AddBtnDisabled__28kOp","AddBtnPlusIcon":"AddBtn_AddBtnPlusIcon__1o6Vh"};